import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { FundStrategy, useGetFundReportQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'SectionOrQuestion',
  setup: function setup(__props) {
    var attrs = useAttrs();
    var question = computed(function () {
      return attrs.question != null ? attrs.question : null;
    });
    var resolvedId = computed(function () {
      return attrs.id != null && attrs.id !== '' ? attrs.id : question.value && question.value.id;
    });
    var resolvedIxId = computed(function () {
      return attrs.ixId != null && attrs.ixId !== '' ? attrs.ixId : question.value && question.value.ixId;
    });
    var resolvedLabel = computed(function () {
      return attrs.label != null && attrs.label !== '' ? attrs.label : question.value && question.value.label;
    });
    var resolvedSublabel = computed(function () {
      return attrs.sublabel != null && attrs.sublabel !== '' ? attrs.sublabel : question.value && question.value.sublabel;
    });
    var resolvedTooltip = computed(function () {
      return attrs.tooltip != null && attrs.tooltip !== '' ? attrs.tooltip : question.value && question.value.tooltip;
    });
    var questionComponent = computed(function () {
      return question.value && question.value.component;
    });
    var questionPromptTemplate = computed(function () {
      return question.value && question.value.promptTemplate;
    });
    var isTopInvestments = computed(function () {
      return resolvedIxId.value === 'topInvestments';
    });
    var isFossilOrNuclear = computed(function () {
      return resolvedIxId.value === 'fossilOrNuclear';
    });
    var isProportionSustainability = computed(function () {
      return resolvedIxId.value === 'proportionSustainabilityRelatedInvestments';
    });
    var isSustainableObjectiveTreeTargets = computed(function () {
      return resolvedIxId.value === 'sustainableObjectiveTreeTargets';
    });
    var isSustainableObjectiveTree = computed(function () {
      return resolvedIxId.value === 'sustainableObjectiveTree';
    });
    var route = useRoute();
    var _useGetFundReportQuer = useGetFundReportQuery(computed(function () {
        return {
          input: {
            id: toNumber(route.params.fund),
            referencePeriodId: toNumber(route.query.referencePeriodId)
          }
        };
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId) && !!route.params.fund
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result;
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return ((_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var investmentsCategorizationChartData = computed(function () {
      return calculatedSfdrReport.value && calculatedSfdrReport.value.investmentsCategorizationChartData ? calculatedSfdrReport.value.investmentsCategorizationChartData : null;
    });
    var show = ref(true);
    return {
      __sfc: true,
      attrs: attrs,
      question: question,
      resolvedId: resolvedId,
      resolvedIxId: resolvedIxId,
      resolvedLabel: resolvedLabel,
      resolvedSublabel: resolvedSublabel,
      resolvedTooltip: resolvedTooltip,
      questionComponent: questionComponent,
      questionPromptTemplate: questionPromptTemplate,
      isTopInvestments: isTopInvestments,
      isFossilOrNuclear: isFossilOrNuclear,
      isProportionSustainability: isProportionSustainability,
      isSustainableObjectiveTreeTargets: isSustainableObjectiveTreeTargets,
      isSustainableObjectiveTree: isSustainableObjectiveTree,
      route: route,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      calculatedSfdrReport: calculatedSfdrReport,
      investmentsCategorizationChartData: investmentsCategorizationChartData,
      show: show,
      FundStrategy: FundStrategy
    };
  }
});